/**
 * @file 处理数据
 * @author guozhihao02
 */

// 所有可能出现的tabs
const TABS = ['车系首页', '车型列表', '实拍图片', '官方图片', '车主口碑', '视频说明书', '测评报告', '同级对比', '精彩资讯'];
// tabs 请求状态，如果已经处理过了，那么将状态改为 1
const TABS_STATUS = [1, 1, 0, 0, 0, 0, 1, 0, 0];
const FINAL_TABS = [{
    id: 'index',
    itemName: '车系首页'
}, {
    id: 'carlist',
    itemName: '车型列表'
}];

// 锚点对应表
function anchor(name) {
    switch (name) {
        case '实拍图片': return 'realpic';
        case '官方图片': return 'officalpic';
        case '视频说明书': return 'videointro';
        case '车主口碑': return 'reputation';
        case '同级对比': return 'contrastclass';
        case '精彩资讯': return 'feeds';
        case '测评报告': return 'guide';
    }
}

export function parseTabs(name, status) {
    const index = TABS.indexOf(name);
    if (index > -1) {
        TABS_STATUS[index] = 1;
        if (status) {
            FINAL_TABS[index] = {
                id: anchor(name),
                itemName: name
            };
        }
    }
    return FINAL_TABS.filter(v => !!v);
}
